<template>
  <div
    class="gmp-devices-page__devices-list"
  >
    <DeviceCard
      v-for="device of devices"
      :key="device.deviceId"
      :device="device"
    />
    <DeviceCard />
  </div>
</template>

<script>
import MediaQueryMixin from '../../../../mixins/MediaQueryMixin';
import DeviceCard from './device/DeviceCard.vue';

export default {
  name: 'DevicesList',
  components: {
    DeviceCard,
  },
  mixins: [MediaQueryMixin],
  props: {
    devices: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
